import React from 'react';
import { RouteComponentProps } from 'react-router';
import { ExamDetailsContainer } from '../../containers';

const ExamDetailsPage = ({ match }: Props) => <ExamDetailsContainer examId={match.params.examId} />;

export default ExamDetailsPage;

interface OwnProps {
    examId: string;
}

type Props = RouteComponentProps<OwnProps>
